module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 42
// module chunks = 0